<template>
	<div class="relative">
		<div class="bg-red text-white absolute rounded-full text-center w-5 h-5 p-0 text-sm">
			<span class="inline-block"><slot></slot></span>
		</div>
	</div>
</template>
